import * as Yup from "yup";

//REVISAR Y COMPLETAR AL MOMENTO DE CONECTAR CON MOBILE, CONOCER LAS VARIABLES Y TENER DISPONIBLES LOS ENDPOINTS

export const serverTasksValidationSchema = Yup.object({
    nextExec: Yup.date("Debe ser formato fecha").required("Requerido"),
    errorCount: Yup.number("Debe ser un numero"),
});
